import { ReactNode } from "react"
import SmallHeadingComponent from "../SmallHeadingComponent"
import CenterContents from "../CenterContents"
import Accordion from "../Accordion"
import SmallestHeadingComponent from "../SmallestHeadingComponent"

export interface InstructionComponentProps {
    name: string
    path: string
    description?: ReactNode
    ios?: {
        description?: ReactNode
        steps?: ReactNode[]
    }
    android?: {
        description?: ReactNode
        steps?: ReactNode[]
    }
    starterkitHome?: {
        description?: ReactNode
        steps?: ReactNode[]
    }
    starterkitOnsite?: {
        description?: ReactNode
        steps?: ReactNode[]
    }
    both?: ReactNode[]
    web?: ReactNode[]
    custom?: ReactNode
}

/**
 * Helper for rendering a list of steps.
 * - If there is only one step, it displays just the content (no "Schritt X" heading).
 * - If there are multiple steps, each gets "Schritt X".
 */
function renderSteps(steps: ReactNode[]) {
    if (steps.length === 1) {
        return <div>{steps[0]}</div>
    } else {
        return steps.map((elem, index) => (
            <div key={index} className="flex flex-col space-y-2">
                <SmallestHeadingComponent>{`Schritt ${index + 1}`}</SmallestHeadingComponent>
                <div>{elem}</div>
            </div>
        ))
    }
}

function InstructionComponent(props: InstructionComponentProps) {
    return (
        <CenterContents>
            <div className="w-full max-w-[1000px] m-5 flex flex-col space-y-8">
                <SmallHeadingComponent>{props.name}</SmallHeadingComponent>

                {props.description && <div>{props.description}</div>}

                {/* iOS Section */}
                {props.ios && (
                    <Accordion title="Schritte für iOS Geräte">
                        <div className="flex flex-col space-y-4">
                            {props.ios.description && (
                                <div>{props.ios.description}</div>
                            )}
                            {props.ios.steps && renderSteps(props.ios.steps)}
                        </div>
                    </Accordion>
                )}

                {/* Android Section */}
                {props.android && (
                    <Accordion title="Schritte für Android Geräte">
                        <div className="flex flex-col space-y-4">
                            {props.android.description && (
                                <div>{props.android.description}</div>
                            )}
                            {props.android.steps && renderSteps(props.android.steps)}
                        </div>
                    </Accordion>
                )}
                {/* Web Section */}
                {props.web && (
                    <div className="flex flex-col space-y-4">
                        {renderSteps(props.web)}
                    </div>
                )}

                {/* Both Section */}
                {props.both && (
                    <div className="flex flex-col space-y-4">
                        {renderSteps(props.both)}
                    </div>
                )}

                {/* Custom Section */}
                {props.custom && props.custom}
            </div>
        </CenterContents>
    )
}

export default InstructionComponent
